import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import HeroSection from "./components/HeroSection";
import SocialProofBar from "./components/SocialProofBar";
import NetworksSection from "./components/NetworksSection";
import HowItWorksSection from "./components/HowItWorksSection";
import FeaturesPreviewSection from "./components/FeaturesPreviewSection";
import ComparisonSection from "./components/ComparisonSection";
import LandingPagesSection from "./components/LandingPagesSection";
import ForumAgentSection from "./components/ForumAgentSection";
import TestimonialsSection from "./components/TestimonialsSection";
import FAQSection from "./components/FAQSection";
import CTASection from "./components/CTASection";
import GrowthAutomationBanner from "./components/GrowthAutomationBanner";
import FeaturedCommunitiesBanner from "./components/FeaturedCommunitiesBanner";
import AffiliateToolsSection from "./components/AffiliateToolsSection";

export default function Home() {
  return (
    <div className="min-h-screen">
      <Navbar />
      <HeroSection />
      <SocialProofBar />
      <HowItWorksSection />
      <GrowthAutomationBanner />
      <FeaturesPreviewSection />
      <NetworksSection />
      <AffiliateToolsSection />
      <ComparisonSection />
      <LandingPagesSection />
      <ForumAgentSection />
      <FeaturedCommunitiesBanner />
      <TestimonialsSection />
      <FAQSection />
      <CTASection />
      <Footer />
    </div>
  );
}
